import { gql } from "@apollo/client";

import complianceProgramTargetFragment from "./compliance-program-target-fragment";

export default gql`
  ${complianceProgramTargetFragment}
  fragment ComplianceProgramReportAnswer on AssessmentAnswerInterface {
    id
    hasCalibrations
    hasCalibrationSuggestions
    ... on RangeAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
    }
    ... on IndividualGoalAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
    }
    ... on OverallGoalAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
    }
    ... on IndividualRecognitionCoreValueAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
    }
    ... on OverallRecognitionCoreValueAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
    }
    ... on ResponsibilityAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
      roleId
    }
    ... on TalentIndicatorAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
    }
    ... on CompetencyAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
      roleId
    }
    ... on CompetencyCriteriaAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
      roleId
    }
    ... on MultiChoiceAssessmentAnswerNode {
      id
      questionId
      choices
      comment
    }
    ... on TextAssessmentAnswerNode {
      id
      questionId
      textAnswer
      comment
    }
    ... on NpsAssessmentAnswerNode {
      id
      questionId
      integerAnswer
      comment
    }
  }
  fragment ComplianceProgramReportAssessment on AssessmentNode {
    id
    state
    responder {
      id
      name
      firstName
      avatar
    }
    target {
      ...ComplianceProgramTarget
    }
    answers(
      questionType: [
        range
        talent_indicator
        overall_goal
        overall_recognition_core_value
      ]
    ) {
      ...ComplianceProgramReportAnswer
    }
    roleAssessmentAvg
    selfRoleAssessmentAvg
    assessmentDelivery {
      id
      state
      canUpdate {
        permission
      }
      deliveryDatetime
      canRead {
        permission
      }
    }
    template {
      id
      organization {
        id
      }
    }
    assessmentDeliveryState
  }
`;
